var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("yxt-input-number", {
        staticStyle: { width: "200px" },
        attrs: {
          step: 5,
          precision: 0,
          "controls-position": "right",
          min: 0,
          max: 1440,
        },
        model: {
          value: _vm.getValue,
          callback: function ($$v) {
            _vm.getValue = $$v
          },
          expression: "getValue",
        },
      }),
      _c("span", { staticClass: "tlive-duration-minites" }, [
        _vm._v(
          "\n  " + _vm._s(_vm.$t("pc_biz_ote_lbl_minites" /* 分钟 */)) + "\n  "
        ),
      ]),
      _c(
        "span",
        { staticClass: "tlive-fast-track" },
        _vm._l(_vm.fastTimeArray, function (time) {
          return _c(
            "span",
            {
              key: time,
              on: {
                click: function ($event) {
                  return _vm.updateDuration(time)
                },
              },
            },
            [_vm._v(_vm._s(time))]
          )
        }),
        0
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }